export default __webpack_public_path__ + "static/media/musk1.17eeaa8b.png";